import { QBankStructureLevelCategory } from '@exam-management/graphql';

import { type LevelItemWithLevel } from '../../types';

import { type AddItemSetQuestionConditionsFormType } from './add-item-set-question-conditions-schema';

export function getDefaultTopicsAndSubTopics(input: {
  levelItems: LevelItemWithLevel[];
  checkExistOnStructures: (id: string) => boolean;
  chapterRefId: string | null;
  initialValues?: AddItemSetQuestionConditionsFormType;
}) {
  const { levelItems, checkExistOnStructures, chapterRefId, initialValues } = input;

  let topicLevelItems = levelItems.filter(
    (item) => item.level.category === QBankStructureLevelCategory.Topic,
  );
  if (topicLevelItems.length === 0) {
    topicLevelItems = levelItems.filter(
      (item) => item.level.category === QBankStructureLevelCategory.Chapter,
    );
  }

  const subTopicLevelItems = levelItems.filter(
    (item) => item.level.category === QBankStructureLevelCategory.SubTopic,
  );

  // check all subtopics
  const topics: Record<string, boolean> = topicLevelItems.reduce((acc, item) => {
    const children = subTopicLevelItems.filter((subItem) => subItem.parentLevelItemId === item.id);
    if (initialValues?.location.topics[item.id] === true) {
      return {
        ...acc,
        [item.id]: true,
      };
    }
    const isAllSelected = children.every((child) => checkExistOnStructures(child.id));
    return {
      ...acc,
      [item.id]: isAllSelected ? undefined : false,
    };
  }, {});

  if (!topicLevelItems.length && chapterRefId) {
    topics[chapterRefId] = subTopicLevelItems
      .filter((subItem) => subItem.parentLevelItemId === chapterRefId)
      .every((child) => checkExistOnStructures(child.id));
  }

  //  check selected
  const subTopics = subTopicLevelItems.reduce((acc, item) => {
    const isAlreadySelected = checkExistOnStructures(item.id);
    if (initialValues?.location.subtopics[item.id] === true) {
      return {
        ...acc,
        [item.id]: true,
      };
    }
    return {
      ...acc,
      [item.id]: isAlreadySelected ? undefined : false,
    };
  }, {});

  return { topics, subTopics };
}
